module.exports = __webpack_public_path__ + "assets/images/598c99bd49d037e1617b81369be5404d.png";